import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../public/assets/images/theme-2/close-white.svg';

import { LoopTopSection, ClosePanelIcon } from './styles';

const TopSection = ({ panel, loading = false }) => {
  return (
    <LoopTopSection>
      <ClosePanelIcon disabled={loading} onClick={() => panel.hide()} src={CloseIcon} />
    </LoopTopSection>
  );
};

export default TopSection;

TopSection.propTypes = {
  panel: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};
